<template>
    <div class="wrap">
        <!-- <div class="head"></div> -->
        <div class="w">

            <div class="view">
                <h2>{{ article.articleTitle }}</h2>
                <div class="subtitle">{{ article.articleSources }}</div>
                <div class="info">
                    发布日期：{{ article.createTimeString }} &nbsp;&nbsp;&nbsp;&nbsp; 浏览次数：{{ article.viewTimes }}
                </div>
                <div class="separator"></div>
                <div class="content" v-html="article.articleContent"></div>
                <div class="attachment_list">
                    <ul>
                        <li v-for="item in article.attachmentList">
                            <a :href="item.path">{{ item.fileName }}</a>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--
        <div class="bg">
            <div class="footer"></div>
        </div>
        -->
    </div>
</template>
<script>
import { apiService, RESULT_CODE } from "@/api/ApiService.js"
    export default {
        name: 'Out',
        data() {
            return {
                article: {}
            }
        },
        mounted () {
            let path = this.$route.params.path
            
            apiService.findArticleByPath(path).then(res => {
                this.article = res.data
                apiService.addViewTimes(res.data.articleId)
            })
            
        }
    }
</script>
<style scoped>
.head {
        height: 140px;
        background-image: linear-gradient(to right, rgba(5, 115, 184, 0.8), rgba(181,204,255, 0.8)) ,url('../assets/imgs/headimg1.jpeg') ;
        background-position: center;
        background-size: cover;
        transition: height 0.5s;
        position: fixed;
        top: 0;
        width: 100%;
        z-index:9999;

    }
.view {
    padding: 0.25rem;
    background-color: #fff;
    margin-top: 140px;;
}

h2 {
    line-height: 0.2rem;
    text-align: center;
    font-size: 0.16rem;
}

.info {
    padding: 0.1rem 0;
    text-align: center;
    color: #999;
    font-size: 0.07rem;

}

.subtitle {
    text-align: center;
    font-size: 16px;
    line-height: 50px;
    color: rgb(34, 34, 34);
}

.separator {
    border-bottom: 1px dashed #e7e7e7;
    margin: 0.08rem;
}

.attachment_list ul {
    display: flex;
    flex-wrap: wrap;
}

.attachment_list ul>li {
    padding: 5px 10px;
    margin-right: 15px;
    background: #ddd;
    border-radius: 5px;
}

.attachment_list ul>li>a {
    color: deepskyblue;
    text-decoration: none;
}
    .bg {
        background-image: url('../assets/imgs/20220909203505.jpg');
        background-size: cover;
        background-position: bottom center;
    }
    .footer {
        height: 240px;
        display: flex;
        justify-content: center;    
        box-sizing: border-box;
        padding: 50px 0.25rem 0;
        background-color: rgb(5, 115, 184, 0.8);
        color: #fff;
        font-size: 0.07rem;
        position: relative;
        user-select: none;
    }
    
</style>


// WEBPACK FOOTER //
// src/pages/Out.vue